import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { StatusJornada } from "src/app/shared/enums/Jornada/StatusJornada";
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";
import { AtividadePsicologoDeslocamento } from "src/app/shared/models/atividade-psicologo/atividade-psicologo-deslocamento";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { RotaMaps } from "src/app/shared/models/maps/rota.model";
import { FimJornada, InicioJornada, JornadaPsicologo } from "src/app/shared/models/psicologo/JornadaPsicologo";
import {
  getDataCheckInModal,
  getDataHoraCheckInEfetiva,
  getHoraCheckInModal,
  getTextoEscolaParaModal,
  getUreModal,
} from "src/app/shared/utils/jornada-em-aberto-modal";
import { UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EscolaService } from "src/app/shared/services/escola.service";
import { RelogioPontoService } from "src/app/shared/services/modal-relogioPonto.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { angularCommonImports } from "src/app/shared/ui/angular-common";
import { convivaCommonImports } from "src/app/shared/ui/conviva-common";
import { libsCommonImports } from "src/app/shared/ui/libs-common";
import { PageDeslocamentoPsicologoComponent } from "../deslocamento/psicologo-deslocamento.component";
import { MapsService } from './../../../../shared/services/maps.service';

@Component({
    templateUrl: './deslocamento-jornada.component.html',
    styleUrls: ['./deslocamento-jornada.component.scss'],
    imports:[angularCommonImports,convivaCommonImports,libsCommonImports,PageDeslocamentoPsicologoComponent],
    standalone: true,
})
export class DeslocamentoJornadaComponent implements OnInit {
  //Serviços
  relogioPontoService = inject(RelogioPontoService);
  escolaService = inject(EscolaService);
  authService = inject(AuthService);
  router = inject(Router);
  toastr = inject(ToastrService);
  deviceService = inject(DeviceDetectorService);
  spinner = inject(NgxSpinnerService);
  psicologoService = inject(PsicologoService);
  mapsService = inject(MapsService);
  ConvivaErrors = inject(ConvivaErrorHandlingService);
  //Variaveis
  modelDeslocamento: AtividadePsicologoDeslocamento | null;
  passoAtual: number = 1;
  userLogado: UserLoginSed | null;
  longitude: string | undefined;
  latitude: string | undefined;
  longitudeDestino: string ;
  latitudeDestino: string ;
  device: string;
  escola: Escola;
  diretoriaDestino: Diretoria;
  mensagemRetornoSucesso: string = '';
  JornadaAtiva: JornadaPsicologo | null;
  public showModalJornadaEmAberto: boolean = false;
  public jornadaEmAbertoParaFechar?: JornadaPsicologo;

  /** Resumo somente leitura do modal “Jornada em aberto” (CA01/CA03). */
  readonly jornadaAbertoResumo = {
    dataCheckIn: getDataCheckInModal,
    horaCheckIn: getHoraCheckInModal,
    ure: getUreModal,
    escola: getTextoEscolaParaModal,
  };
  public horaEncerramentoJornadaEmAberto: string = '';
  public submittedHoraEncerramentoJornadaEmAberto: boolean = false;
  public erroHoraEncerramentoJornadaEmAberto: string = '';
  motivoSelecionado: string = '';
  motivoOutro: string = '';
  infoRegistroPontoSucesso: boolean;
  submmited: boolean;


  get validaConexaoUsuario(): boolean {
    return !this.latitude
      && !this.longitude
      && !this.mensagemRetornoSucesso
      && !this.JornadaAtiva;
  }

  async ngOnInit() {
    this.getUserLogado();
    // await this.getEscolaAtual();
    await this.getLocation();
  }

  getUserLogado() {
    this.userLogado = this.authService.getUser();
    if (!this.userLogado)
      this.router.navigate(['/logout']);

  }



  public async proximoPassoDeslocamento(modelDeslocamento: AtividadePsicologoDeslocamento) {

    this.modelDeslocamento = modelDeslocamento;
    if(this.modelDeslocamento.codigoEscolaDestino != 0 )
      await this.getEscolaAtual();
    else
      await this.getDiretoriaDestinho(this.modelDeslocamento.codigoDiretoriaDestino);

    this.passoAtual = 2;
  }


  setNovoPasso(event: unknown) {
    this.passoAtual = event as number;
  }


  async getLocation(): Promise<void> {

    const deviceInfo = this.deviceService.getDeviceInfo();



    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
    }

    // console.log(deviceInfo);

    if ('geolocation' in navigator) {
      // Configurações para alta precisão
      const options: PositionOptions = {
        enableHighAccuracy: true, // Ativa alta precisão
        timeout: 5000, // Tempo máximo de espera
        maximumAge: 0, // Não usar cache
      };

      // Solicita a localização
      await navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {

          this.latitude = position.coords.latitude.toString();
          this.longitude = position.coords.longitude.toString();
          this.device = deviceInfo.deviceType;

          // this.toastr.success(`Lat: ${position.coords.latitude}, Long: ${position.coords.longitude}`);
        },
        (error: GeolocationPositionError) => {
          this.toastr.error(`Erro ao obter a localização: ${error.message}`);
          // console.error(error); // Retorna o erro
        },
        options
      );

    } else {
      this.toastr.error(`Geolocalização não suportada neste navegador.`);

      console.error('Geolocalização não suportada neste navegador.');
    }
  }




  async getEscolaAtual() {
    this.spinner.show();
    const response = await lastValueFrom(this.escolaService.getEscolaDetalhes(this.modelDeslocamento?.codigoEscolaDestino!));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinner.hide();
      return;
    }

    this.escola = response.data;
    this.latitudeDestino  = this.escola.latitude
    this.longitudeDestino  = this.escola.longitude
    this.spinner.hide();
  }

  async RegistrarInicioJornada() {
    if (await this.tentarAbrirModalJornadaEmAbertoAntesDeIniciar()) {
      return;
    }
    await this.registrarInicioJornadaCore();
  }

  private async tentarAbrirModalJornadaEmAbertoAntesDeIniciar(): Promise<boolean> {
    if (!this.userLogado?.cpf) return false;
    this.spinner.show();
    try {
      const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(this.userLogado.cpf));
      if (!response.isSucess) {
        this.toastr.error(response.message, response.title);
        return false;
      }

      if (response.data) {
        this.jornadaEmAbertoParaFechar = response.data;
        this.horaEncerramentoJornadaEmAberto = '';
        this.submittedHoraEncerramentoJornadaEmAberto = false;
        this.erroHoraEncerramentoJornadaEmAberto = '';
        this.showModalJornadaEmAberto = true;
        return true;
      }

      return false;
    } finally {
      this.spinner.hide();
    }
  }

  private async registrarInicioJornadaCore() {
    if (this.userLogado?.codigoPerfil != Perfil.Psicólogo && this.userLogado?.codigoPerfil != Perfil.CoordenadorPsicologo) {
      this.toastr.error('Apenas psicólogos e Coordenador Psicólogos podem registrar jornada de trabalho!');
      return;
    }

    this.spinner.show();
    this.submmited = true;
    if (this.validaConexaoUsuario && this.motivoSelecionado === "") {
      this.toastr.error("Selecione um motivo");
      this.spinner.hide();
      this.submmited = false;
      return;
    }

    if (this.motivoSelecionado == "Outros" && (this.motivoOutro === "" || this.motivoOutro.length <= 150)) {
      this.toastr.error("Descrição vazia ou menor que 150 caracteres");
      this.spinner.hide();
      this.submmited = false;
      return;

    }

    const body = await this.setBodyRegistroPonto();
    try {
      const response = await lastValueFrom(this.psicologoService.registraInicioJornada(body!));
      if (!response.isSucess) {
        this.toastr.error(response.message, response.title);
        this.infoRegistroPontoSucesso = false;
        this.submmited = false;
        this.relogioPontoService.updateStatusJornada(StatusJornada.ComErro);
        this.spinner.hide();
        return;
      }

      this.mensagemRetornoSucesso = response.data.mensagem;

      // #162971 — status verde imediato após check-in.
      this.relogioPontoService.updateStatusJornada(StatusJornada.Iniciada);
      this.toastr.success(`Registro de Entrada na Escola com sucesso!`);
      this.infoRegistroPontoSucesso = true;
      this.submmited = false;

      this.spinner.hide();
      await this.sincronizarJornadaAposCheckinDeslocamento(response.data?.codigoGrande);
    } catch (error: any) {
      const mensagem =
        error?.error?.message
        || error?.message
        || 'Não foi possível registrar o check-in. Verifique a conexão e tente novamente.';
      this.toastr.error(mensagem, 'Erro no check-in');
      this.infoRegistroPontoSucesso = false;
      this.submmited = false;
      this.relogioPontoService.updateStatusJornada(StatusJornada.ComErro);
      this.spinner.hide();
    }

  }

  /** #162971 — Confirma jornada aberta após check-in via deslocamento, sem rebaixar o status. */
  private async sincronizarJornadaAposCheckinDeslocamento(codigoJornadaCriada?: number | null): Promise<void> {
    const maxTentativas = 3;
    for (let tentativa = 1; tentativa <= maxTentativas; tentativa++) {
      try {
        const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(this.userLogado?.cpf!));
        if (response?.isSucess && response.data !== null) {
          this.relogioPontoService.updateStatusJornada(StatusJornada.EmAndamento);
          return;
        }
      } catch {
        // retry abaixo
      }
      if (tentativa < maxTentativas) {
        await new Promise(resolve => setTimeout(resolve, 300 * tentativa));
      }
    }

    this.relogioPontoService.updateStatusJornada(StatusJornada.EmAndamento);
    if (codigoJornadaCriada && codigoJornadaCriada > 0) {
      // codigoGrande já garante sincronização otimista do status; painel reconsulta no fechamento do modal.
    }
  }

  public fecharModalJornadaEmAberto() {
    this.showModalJornadaEmAberto = false;
    this.jornadaEmAbertoParaFechar = undefined;
    this.horaEncerramentoJornadaEmAberto = '';
    this.submittedHoraEncerramentoJornadaEmAberto = false;
    this.erroHoraEncerramentoJornadaEmAberto = '';
  }

  public async confirmarEncerramentoJornadaEmAberto() {
    this.submittedHoraEncerramentoJornadaEmAberto = true;
    this.erroHoraEncerramentoJornadaEmAberto = '';
    if (!this.jornadaEmAbertoParaFechar) return;
    if (!this.horaEncerramentoJornadaEmAberto) return;
    if (!/^\d{2}:\d{2}$/.test(this.horaEncerramentoJornadaEmAberto)) {
      this.erroHoraEncerramentoJornadaEmAberto = 'Horário de encerramento inválido. Use o formato HH:mm.';
      return;
    }

    const abertura = getDataHoraCheckInEfetiva(this.jornadaEmAbertoParaFechar);
    const [hhStr, mmStr] = this.horaEncerramentoJornadaEmAberto.split(':');
    const hh = Number(hhStr);
    const mm = Number(mmStr);
    if (Number.isNaN(hh) || Number.isNaN(mm)) {
      this.erroHoraEncerramentoJornadaEmAberto = 'Horário de encerramento inválido. Use o formato HH:mm.';
      return;
    }

    // Mantém a data igual ao dia de abertura da jornada e aplica apenas o horário informado (horário local).
    const dataFim = new Date(abertura.getFullYear(), abertura.getMonth(), abertura.getDate(), hh, mm);

    // Regra CA09: não pode encerrar antes do horário de início.
    if (dataFim.getTime() < abertura.getTime()) {
      this.erroHoraEncerramentoJornadaEmAberto = 'O horário de encerramento não pode ser anterior ao horário de início da jornada.';
      return;
    }

    // Envia data/hora como string local (sem Z) para evitar conversão para UTC e garantir precisão de HH:mm no backend.
    const pad2 = (n: number) => String(n).padStart(2, '0');
    const y = abertura.getFullYear();
    const mo = pad2(abertura.getMonth() + 1);
    const da = pad2(abertura.getDate());
    const dataFimParaApi = `${y}-${mo}-${da}T${pad2(hh)}:${pad2(mm)}:00`;

    this.spinner.show();
    try {
      let codigoPolo = this.userLogado?.codigoPolo;
      if (!codigoPolo || codigoPolo === 0) {
        const polo = await lastValueFrom(this.psicologoService.getPoloPsicologo(this.userLogado?.cpf!));
        if (!polo.isSucess) {
          this.toastr.error(polo.message, polo.title);
          return;
        }
        codigoPolo = polo.data.codigoPolo;
      }

      // OBS: também envia em PascalCase para garantir bind (evita cair no NTP/hora atual quando `dataFim` não é parseado).
      const bodyFim: FimJornada & Record<string, unknown> = {
        codigoJornada: this.jornadaEmAbertoParaFechar.codigoJornada,
        dataFim: dataFimParaApi,
        tipoRegistro: 1, // Automatico (o backend atualiza como Automatico)
        codigoUsuario: this.userLogado?.codigoUsuario ?? Number(this.userLogado?.cpf ?? 0),
        nomeUsuario: this.userLogado?.nome ?? '',
        longitude: this.longitude,
        latitude: this.latitude,
        cpfPsicologo: this.userLogado?.cpf,
        codigoPolo,
        NrCpfCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? this.userLogado?.cpf : undefined,
        FlCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? true : undefined,

        // Aliases PascalCase
        CodigoJornada: this.jornadaEmAbertoParaFechar.codigoJornada,
        DataFim: dataFimParaApi,
        TipoRegistro: 1,
        CodigoUsuario: this.userLogado?.codigoUsuario ?? Number(this.userLogado?.cpf ?? 0),
        NomeUsuario: this.userLogado?.nome ?? '',
        Latitude: this.latitude,
        Longitude: this.longitude,
        CPFPsicologo: this.userLogado?.cpf,
      };

      const responseFim = await lastValueFrom(this.psicologoService.registraFimJornada(bodyFim));
      if (!responseFim.isSucess) {
        this.toastr.error(responseFim.message, responseFim.title);
        return;
      }

      // Fecha o modal e prossegue para iniciar a nova jornada.
      this.fecharModalJornadaEmAberto();
      await this.registrarInicioJornadaCore();
    } finally {
      this.spinner.hide();
    }
  }


  async setBodyRegistroPonto(): Promise<InicioJornada | void> {

    let deslocamento: RotaMaps | undefined;
    const polo = await lastValueFrom(this.psicologoService.getPoloPsicologo(this.userLogado?.cpf!));
    if (!polo.isSucess) {
      this.toastr.error(polo.message, polo.title);
      return;
    }

    if (this.userLogado?.autorizacaoUsoDados == 1 && await this.validarLatLong()) {
      deslocamento = await this.mapsService.calculateDistance(
        +this.latitude!, +this.longitude!,
        +this.latitudeDestino!, +this.longitudeDestino!);
      // console.log(`${deslocamento?.totalKm} km`)
      // console.log(deslocamento)

    }
    const body: InicioJornada = {
      CpfPsicologo: this.userLogado?.cpf!,
      CodigoPolo: polo.data.codigoPolo,
      CodigoDiretoria: this.modelDeslocamento?.codigoDiretoriaDestino!,
      CodigoEscola: this.modelDeslocamento?.codigoEscolaDestino,
      TipoRegistroInicio: 1,
      NomeUsuario: this.userLogado?.nome!,
      CodigoUsuario: Number(this.userLogado?.cpf!),
      LatitudeInicio: this.userLogado?.autorizacaoUsoDados == 1 ? this.latitude : undefined,
      LongitudeInicio: this.userLogado?.autorizacaoUsoDados == 1 ? this.longitude : undefined,
      Observacao: this.tratarObservacao(),
      DistanciaEscola: deslocamento?.totalKmFormatado,
      TempoDeslocamento: deslocamento?.totalDuration,
      Deslocamento: this.modelDeslocamento,
      NrCpfCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? this.userLogado?.cpf : undefined,
      FlCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? true : undefined

    };

    return body;

  }


  public async validarLatLong(): Promise<boolean> {

    if (!this.longitude || !this.latitude)
      return false;


    if (+this.latitudeDestino != 0 &&
      +this.longitudeDestino != 0 &&
      +this.latitude! != 0 &&
      +this.longitude! != 0) {
      return true;
    }

    if (this.latitudeDestino && +this.latitudeDestino == 0
      && this.longitudeDestino && +this.longitudeDestino == 0) {
      this.toastr.error(`A Diretoria/Escola está com problema na Lat/Long ... `, 'Atenção!');
    }

    if (this.latitude && +this.latitude == 0
      && this.longitude && +this.longitude == 0) {
      this.toastr.error(`Há um problema na sua Lat/Long ... `, 'Atenção!');
    }

    return false;
  }

  private tratarObservacao() {
    let observacao = this.motivoSelecionado;

    if (this.motivoSelecionado == "Outros") {
      observacao = this.motivoOutro;
    }

    if (this.userLogado?.autorizacaoUsoDados != 1) {
      observacao = "Sem autorização do uso de dados";
    }

    return observacao;
  }

  redirectToHome() {
    this.router.navigate(['/home']);
  }


  public async getDiretoriaDestinho(codigoDiretoria:number){
    this.spinner.show();
    const resultDiretoria = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(codigoDiretoria)).catch((err) => {
                                        return this.ConvivaErrors.handleResultError(err);
                                      });

    if(!resultDiretoria.isSucess){
        this.toastr.error(resultDiretoria.message);
        this.spinner.hide();
        return;
    }

    this.diretoriaDestino = resultDiretoria.data[0];
    this.latitudeDestino = this.diretoriaDestino.latitude;
    this.longitudeDestino = this.diretoriaDestino.longitude;

    this.spinner.hide();
  }

}
